"use no memo";

import { type ReactNode } from "react";

import { Heading } from "@stacklet/ui";
import { FormProvider, type UseFormReturn } from "react-hook-form";

import { HelpDrawerTrigger } from "app/components/HelpDrawer/HelpDrawerTrigger";

import { type GroupFormSchema } from "./GroupSchema";

interface Props {
  /** The form title to display */
  title: string;
  /** Form instance from react-hook-form */
  form: UseFormReturn<GroupFormSchema>;
  /** Form submit handler */
  onSubmit: () => void;
  /** Form content to render */
  children: ReactNode;
}

export function GroupFormLayout({ title, form, onSubmit, children }: Props) {
  return (
    <>
      <div className="mb-xl flex items-center justify-between">
        <Heading level={2}>{title}</Heading>
        <HelpDrawerTrigger />
      </div>

      <form onSubmit={onSubmit}>
        <FormProvider {...form}>{children}</FormProvider>
      </form>
    </>
  );
}
